import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetAuthURL($businessId: String!, $client: GetAuthURLRequestClientType) {
    getAuthURL(businessId: $businessId, client: $client) {
      url
    }
  }
`

export const getAuthURLKey = getQueryNames(query)[0]

export default query
